
import dayjs from "dayjs";
import { Component, Prop, Vue } from "vue-property-decorator";
import Tag from "@/components/tags/Tag.vue";
import { ProchaineActivite } from "@/models";

@Component({
  components: { Tag },
})
/**
 * Mini 5-day calendar strip.
 * @remarks Imported and registered in Recyclage.vue and Onboarding.vue, but the `<card-calendrier>`
 * tag never actually appears in either template — dead in practice despite being wired up.
 */
export default class CardCalendrier extends Vue {
  @Prop({ required: true }) calendrier!: ProchaineActivite[] | null;

  /** Formats "today + dayAjout days" as `DD/MM` for a column header. */
  private libelleDate(dayAjout: number): string {
    return dayjs().add(dayAjout, "day").format("DD/MM");
  }

  /** Activities from `activites` falling on the given `DD/MM` date. */
  private activitesDay(
    activites: ProchaineActivite[],
    date: string
  ): ProchaineActivite[] {
    return activites.filter((a) => dayjs(a.debut).format("DD/MM") === date);
  }
}
